module.exports = __webpack_public_path__ + "img/bronze.be5030ca.webp";